module.exports = __webpack_public_path__ + "media/img/favicon/mstile-150x150-528eb70a72ae6ef13ba82e55a1388e8a.png";